import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Header from "../../header/Header";
import HeaderModulo from "../../header/HeaderModulo";
import Aside from "../../aside/Aside";
import { alerta, toast, formatDate } from '../../../services/utilities';
import { getDia } from '../../../services/Loterias';
import { getReporteVentaLoteria } from '../../../services/Reportes';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';

const LIMITE_INICIAL = 100;

function VentaPorLoteria(props){

    const [spinerLoterias, setSpinerLoterias] = useState(true);
    const [listaLoterias, setListaLoterias] = useState([]);
    const [listaVentas, setlistaVentas] = useState([]);
    const [spinerTabla, setSpinerTabla] = useState(false);
    const [verMensaje, setVerMensaje] = useState(true);
    const [verTable, setVerTable] = useState(false);
    const [filterTabla, setFilterTabla] = useState('');

    const [filtro, setFiltro] = useState({
        "fecha_ini": formatDate(new Date()),
        "id_loteria": "",
        "id_categoria_modalidad_juego": ""
    });

    useEffect(() => {
        let componenteActivo = true;
        setSpinerLoterias(true);

        getDia(filtro.fecha_ini).then((response) => {
            if(!componenteActivo) return;

            if(response.status !== undefined && response.status === 200){
                setListaLoterias(Array.isArray(response.data.data) ? response.data.data : []);
            }else{
                setListaLoterias([]);
                toast('No hay loterías disponibles para la fecha seleccionada','');
            }
        }).catch((error) => {
            if(componenteActivo){
                setListaLoterias([]);
                alerta('Error no controlado al cargar las loterías del día ->' + error);
            }
        }).finally(() => {
            if(componenteActivo) setSpinerLoterias(false);
        });

        return () => {
            componenteActivo = false;
        };
    }, [filtro.fecha_ini]);

    const formatearMoneda = (value) =>{
        const valor = parseFloat(value);
        if (!isNaN(valor)) { 
          value = valor.toLocaleString('es-CO', {minimumFractionDigits: 0});
        }else{
            value = 0;
        }
        return value;
    }

    const handleInputFiltroChange = (event) => {
        const { name, value } = event.target;
        setFiltro((filtroActual) => ({
            ...filtroActual,
            [name]: value,
            ...(name === 'fecha_ini' || name === 'id_categoria_modalidad_juego'
                ? { id_loteria: '' }
                : {})
        }));
    };

    const estaMarcada = (valor) => valor === true || valor === 1 || valor === '1' || valor === 'true';
    const loteriasFiltradas = listaLoterias.filter((loteria) => {
        if(filtro.id_categoria_modalidad_juego === '2'){
            return estaMarcada(loteria.oficial);
        }

        if(filtro.id_categoria_modalidad_juego === '3'){
            return estaMarcada(loteria.astro);
        }

        return true;
    });

    const filterDataTabla = listaVentas.filter((item) => {
        const texto = filterTabla.toLowerCase();
        return [item.loteria, item.tipo_juego, item.modalidad, item.id_transaccion, item.numero, item.valor]
            .some((valor) => String(valor ?? '').toLowerCase().includes(texto));
    });

    const obtenerVentas = (data) => {
        if (Array.isArray(data.ventas)) return data.ventas;
        if (Array.isArray(data.data)) return data.data;
        if (Array.isArray(data.registros)) return data.registros;
        return [];
    };

    const handleBuscarVentas = async () => {

        setVerMensaje(false);
        setSpinerTabla(true);
        setVerTable(false);

        try {
            await getReporteVentaLoteria(
                filtro.fecha_ini,
                filtro.id_loteria,
                filtro.id_categoria_modalidad_juego
            ).then( response => {

                if(response.status !== undefined && response.status === 200){
                    const ventas = obtenerVentas(response.data);
                    setlistaVentas(ventas);

                    if(ventas.length > 0){
                        setVerTable(true);
                    }else{
                        setVerMensaje(true)
                        setVerTable(false);
                    }

                }else{
                    toast('Error al ejecutar la consulta','');
                }
            });

         }catch (error) {
            alerta('Error no controlado al cargar el reporte de venta por lotería ->'+ error);
        }finally {
            setSpinerTabla(false);
        }
    }

    const totalPagina = filterDataTabla.reduce((acumulado, venta) => acumulado + Number(venta.valor || 0), 0);
    const total = totalPagina;

    const numeroCompleto = (venta) => {
        const complemento = venta.tipo_juego === 'QUINTA'
            ? venta.serie
            : venta.tipo_juego === 'ASTROS' ? venta.astro : '';
        return complemento ? `${venta.numero} - ${complemento}` : venta.numero;
    };

    const fechaBody = (venta) => venta.fecha;
    const cantidadBody = (venta) => <span className="badge text-bg-warning"># {venta.cantidad_venta}</span>;
    const numeroBody = (venta) => <span><span className="badge text-bg-info">{venta.numero}</span>{numeroCompleto(venta) !== venta.numero ? ` - ${numeroCompleto(venta).split(' - ').slice(1).join(' - ')}` : ''}</span>;
    const valorBody = (venta) => `$ ${formatearMoneda(venta.valor)}`;
    const skeletonRows = Array.from({ length: 8 }, (_, index) => ({ id: index }));
    const skeletonBody = () => <Skeleton width="100%" height="1.6rem" />;

    return(
        <React.Fragment>
            <Header></Header>
            <Aside></Aside>
            <main id="main" className="main">
                <HeaderModulo nombre_modulo={props.modulo}></HeaderModulo>
                <section className="section">
                    <div className='row'>
                        <div className='col-md-2 mb-3'>
                            <label className="mb-1">Fecha:</label>
                            <div className="input-group">
                                <input 
                                    type="date" 
                                    className="form-control" 
                                    id="fecha_ini" 
                                    name="fecha_ini" 
                                    value={filtro.fecha_ini}
                                    max={formatDate(new Date())}
                                    onChange={handleInputFiltroChange} 
                                />
                            </div>
                        </div>
                        <div className='col-md-2 mb-3'>
                            <label className="mb-1">Modalidades:</label>
                            <div className='input-group'>
                                <select
                                    className="form-select form-control"
                                    name="id_categoria_modalidad_juego"
                                    value={filtro.id_categoria_modalidad_juego}
                                    onChange={handleInputFiltroChange}
                                >
                                    <option value="">Todas</option>
                                    <option value="1">Apuesta</option>
                                    <option value="2">Quinta</option>
                                    <option value="3">Astros</option>
                                    <option value="6">Gane Mas</option>
                                </select>
                            </div>
                        </div>
                        <div className='col-md-2 mb-3'>
                            <label className="mb-1">Loterías</label>
                            {spinerLoterias ?
                                <div className="d-flex">
                                    <div className="spinner-border" role="status"></div>
                                </div>
                            :
                                <div className='input-group'>
                                    <select
                                        className="form-select form-control"
                                        name="id_loteria"
                                        value={filtro.id_loteria}
                                        onChange={handleInputFiltroChange}
                                        disabled={spinerLoterias}
                                    >
                                        <option value="">Todas</option>
                                        {loteriasFiltradas.map((loteria) => (
                                            <option value={loteria.id_loteria} key={loteria.id_loteria}>{loteria.prefijo}</option>
                                        ))}
                                    </select>
                                </div>
                            }
                        </div>
                        { verTable ?
                        <div className="col-md-3">
                            <label className="mb-1">&emsp;</label>
                            <div className="input-group">
                                <span className="input-group-text" id="basic-addon1"><i className="bi bi-search"></i></span>
                                <input 
                                    type="text" 
                                    className="form-control form-control-sm" 
                                    placeholder="Buscar..." 
                                    aria-label="Buscar" 
                                    aria-describedby="basic-addon1" 
                                    value={filterTabla}
                                    onChange={(e) => setFilterTabla(e.target.value)} 
                                />
                            </div>
                        </div>
                        : ''}
                        <div className="col-md-1">
                            <label className="mb-1">&emsp;</label>
                            <div className="input-group">
                                <button 
                                    type="button" 
                                    className="btn btn-outline-primary btn-md"
                                    onClick={handleBuscarVentas}
                                    disabled={spinerTabla}
                                >
                                    Buscar
                                </button>
                            </div>
                        </div>
                    </div>                    
                    {verTable ?
                    <>
                        <div className="row mb-2">
                            <div className="col-md-3 mt-1">
                                <div className="card-totales-venta">
                                    <h6 className="m-0"><b>V. Bruta</b></h6>
                                    <h6 className="text-secondary m-0"><b>$ {formatearMoneda(total)}</b></h6>
                                </div>
                            </div>
                        </div>
                        <div className="d-flex justify-content-end align-items-center mb-1">
                            <span className="text-secondary mx-4" style={{ fontSize: '12px' }}>
                                Total registros: {filterDataTabla.length}
                            </span>
                        </div>

                        <div className="card">
                            <div className="card-body">
                                <DataTable
                                    value={filterDataTabla}
                                    size="small"
                                    rowHover
                                    responsiveLayout="scroll"
                                    emptyMessage="No hay ventas para mostrar"
                                    paginator
                                    rows={LIMITE_INICIAL}
                                    rowsPerPageOptions={[50, 100, 250, 500]}
                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                                    currentPageReportTemplate="{first} a {last} de {totalRecords}"
                                    style={{ fontSize: '12px' }}
                                >
                                    <Column field="fecha" header="Fecha" body={fechaBody} style={{ whiteSpace: 'nowrap' }} />
                                    <Column field="loteria" header="Lotería" />
                                    <Column field="cantidad_venta" header="Cantidad juegos" body={cantidadBody} />
                                    <Column field="tipo_juego" header="Tipo juego" />
                                    <Column field="modalidad" header="Modalidad" />
                                    <Column field="numero" header="Número" body={numeroBody} />
                                    <Column field="valor" header="Acumulado" body={valorBody} />
                                </DataTable>
                            </div>
                        </div>
                    </>
                    :''}
                    {spinerTabla ?
                    <div className="card mt-3">
                        <div className="card-body">
                            <div className="row mb-3">
                                <div className="col-md-3"><Skeleton height="3rem" /></div>
                                <div className="col-md-3"><Skeleton height="3rem" /></div>
                            </div>
                            <DataTable value={skeletonRows} size="small" responsiveLayout="scroll">
                                <Column header="Fecha" body={skeletonBody} />
                                <Column header="Lotería" body={skeletonBody} />
                                <Column header="Cantidad juegos" body={skeletonBody} />
                                <Column header="Tipo juego" body={skeletonBody} />
                                <Column header="Modalidad" body={skeletonBody} />
                                <Column header="Número" body={skeletonBody} />
                                <Column header="Acumulado" body={skeletonBody} />
                            </DataTable>
                        </div>
                    </div>
                    :''}
                    {verMensaje ?
                    <div className='text-center text-secondary my-4'>
                        <h3>Sin resultado de búsqueda para los filtros aplicados.</h3>
                        <p>Por favor elija una combinación de filtros diferente.</p>
                    </div>
                    :''}
                </section>
            </main>
        </React.Fragment>
    );
}

const mapSateToProps = state => {
    return {
        data_sesion: state.data_sesion,
    }
}

export default connect(mapSateToProps, null)(VentaPorLoteria)
